export class ApplicationFilter {
  jurisdiction: string[];
  intentOfGeneration: string[];
}
